import { FormValidator } from '@estee/elc-form';

import { mixed, string } from 'yup';
import { PrimitiveValueType } from './Config';

interface IOneOfValidatorParams {
    values: PrimitiveValueType[];
    required: boolean;
    errorMessage: string;
}

type EmailValidatorParamsType =
    | string
    | {
          // Allow foo.@bar.com
          allowNameEndsWithDot: boolean;
          errorMessage: string;
      };

// Extends FormValidator with RAMP field validations
export class RampFormValidator extends FormValidator {
    constructor() {
        super();
        this.registerValidation('oneOf', this.oneOf);
        // this overrides the one defined in base FormValidator
        this.registerValidation('email', this.validateEmail);
    }

    public oneOf = ({ values, required = false, errorMessage }: IOneOfValidatorParams) => {
        const schema = mixed().oneOf(values, errorMessage);
        if (required) {
            return schema.required(errorMessage);
        }

        return schema;
    };

    public validateEmail = (params: EmailValidatorParamsType) => {
        if (typeof params !== 'string') {
            const { errorMessage, allowNameEndsWithDot } = params;

            return allowNameEndsWithDot
                ? string().test({
                      name: 'allow-name-ends-with-dot-email-test',
                      message: errorMessage,
                      test: (value) => {
                          const noDotValue =
                              typeof value === 'string' ? value.replace(/\.+(?=@)/g, '') : value;

                          return string().email(errorMessage).isValidSync(noDotValue);
                      }
                  })
                : string().email(errorMessage);
        }

        return string().email(params);
    };
}
